import { createFileRoute } from "@tanstack/react-router";
import { requireOnboardingSignUpAnonymous } from "@/lib/auth-guard";

export const Route = createFileRoute("/onboarding/sign-up")({
  beforeLoad: requireOnboardingSignUpAnonymous,
});
